import { mapState } from 'vuex';

import { getSsrUigsParams } from '../js/util';

export default {
  computed: {
    ...mapState('common', ['$config']),
  },
  beforeMount() {
    // anti 校验信息
    const { uuid, approveToken, idc } = this.$config || {};
    this.sendApprove(uuid, approveToken);
    window.UIGS_PARA = getSsrUigsParams({ idc });
    this.$uigs.send({ ...window.UIGS_PARA, isApprove: approveToken ? 1 : 0 });
  },
  methods: {
    sendApprove(uuid, approveToken) {
      if (uuid && approveToken) {
        const img = new Image();
        img.src = `/approve?uuid=${encodeURIComponent(uuid)}&token=${encodeURIComponent(approveToken)}`;
      }
    },
  },
};
